import React from 'react';
import { Link } from 'react-router-dom';
import './TreatmentPage.css';

import SadhanPalakuri   from '../assets/images/SadhanPalakuri.jpeg';




export default function Orthopaedics() {
  return (
    <div>
      <section className="tx-hero" style={{backgroundImage:"url(https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1400&q=80)"}}>
        <div className="tx-hero-overlay"/>
        <div className="container tx-hero-content">
          <div className="breadcrumb"><Link to="/">Home</Link><span className="sep">›</span><span>Sports Orthopaedics</span></div>
          <span className="tx-hero-badge" style={{background:'#0F6E5633',color:'#fff'}}>Sports Focused</span>
          <h1>Sports Orthopaedics</h1>
          <p>Precision surgical and non-surgical orthopaedic care for athletes and active individuals seeking faster, lasting recovery.</p>
          <div style={{display:'flex',gap:14,marginTop:28,flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-acc">Book Consultation →</Link>
            <a href="#procedures" className="btn-ghost-w">View Procedures</a>
          </div>
        </div>
      </section>

      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div className="intro-grid">
            <div>
              <div className="tag-line"><span>Sports Medicine</span></div>
              <h2 className="sec-title">Advanced Sports <span className="acc">Orthopaedic Care</span></h2>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:16}}>Our sports orthopaedics division is built around one goal — getting you back to full performance as quickly and safely as possible. Whether you're a professional athlete or an active individual, we provide the same world-class care.</p>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:28}}>Dr. Sadhan Palakuri combines arthroscopic surgical precision with regenerative orthobiology for outcomes that go beyond conventional orthopaedic surgery.</p>
              <div className="benefit-list">
                <div className="benefit-item"><span className="b-check">✓</span>Minimally invasive arthroscopic surgery</div>
                <div className="benefit-item"><span className="b-check">✓</span>Same-day surgery options</div>
                <div className="benefit-item"><span className="b-check">✓</span>Biological healing with OrthoBiologics</div>
                <div className="benefit-item"><span className="b-check">✓</span>Sports-specific rehabilitation protocols</div>
                <div className="benefit-item"><span className="b-check">✓</span>Return to sport in minimal time</div>
                <div className="benefit-item"><span className="b-check">✓</span>Fellowship-trained specialist</div>
              </div>
            </div>
            <div className="intro-img">
              <img src="https://images.unsplash.com/photo-1552072092-7f9b8d63efcb?w=700&q=80" alt="Sports orthopaedics" style={{borderRadius:20,width:'100%',height:420,objectFit:'cover'}}/>
            </div>
          </div>
        </div>
      </section>

      <section id="procedures" className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:52}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Procedures</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Orthopaedic <span className="acc">Procedures</span></h2>
          </div>

          <div className="proc-row">
            <div className="proc-img"><img src="https://images.unsplash.com/photo-1551076805-e1869033e561?w=600&q=80" alt="Arthroscopy"/></div>
            <div className="proc-text">
              <div className="proc-num">01</div>
              <h3>Arthroscopy — Minimally Invasive Joint Surgery</h3>
              <p>Arthroscopy is a keyhole surgical technique used to diagnose and treat joint problems through tiny incisions. A small camera (arthroscope) is inserted to view the joint on a screen, while thin instruments perform the repair.</p>
              <p style={{marginTop:12}}>Compared to open surgery, arthroscopy means smaller scars, shorter hospital stays, faster recovery, and significantly less post-operative pain. We perform arthroscopy of the knee, shoulder, ankle, hip, and elbow.</p>
              <div className="proc-chips">
                <span>Knee Arthroscopy</span><span>Shoulder Arthroscopy</span><span>Meniscus Repair</span><span>Rotator Cuff</span><span>ACL Repair</span>
              </div>
            </div>
          </div>

          <div className="proc-row reverse">
            <div className="proc-img"><img src="https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?w=600&q=80" alt="OrthoBiologics"/></div>
            <div className="proc-text">
              <div className="proc-num">02</div>
              <h3>Regenerative OrthoBiologics</h3>
              <p>Regenerative OrthoBiologics applies biological agents — PRP, BMAC, and stem cells — directly to orthopaedic injuries to enhance and accelerate natural tissue healing. This approach is used both as standalone treatment and as an augmentation to surgical procedures.</p>
              <p style={{marginTop:12}}>By combining surgery with biologic enhancement, we improve healing quality, reduce re-injury risk, and help patients recover faster with better long-term outcomes.</p>
              <div className="proc-chips">
                <span>PRP Augmentation</span><span>BMAC Injection</span><span>Cartilage Repair</span><span>Tendon Healing</span>
              </div>
            </div>
          </div>

          <div className="proc-row">
            <div className="proc-img"><img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&q=80" alt="Knee Replacement"/></div>
            <div className="proc-text">
              <div className="proc-num">03</div>
              <h3>Knee Joint Replacement</h3>
              <p>When regenerative options are no longer sufficient, total or partial knee replacement using modern prosthetics is performed. We use the latest implant technology and rapid recovery protocols to get patients mobile faster.</p>
              <p style={{marginTop:12}}>At TheOrthomed, knee replacement is always the last resort — we first explore all regenerative and minimally invasive options. When it is needed, we ensure the best possible outcome with comprehensive physiotherapy follow-up.</p>
              <div className="proc-chips">
                <span>Total Knee Replacement</span><span>Partial Replacement</span><span>Revision Surgery</span>
              </div>
            </div>
          </div>

          <div className="proc-row reverse">
            <div className="proc-img"><img src="https://images.unsplash.com/photo-1552072092-7f9b8d63efcb?w=600&q=80" alt="Ligament Repair"/></div>
            <div className="proc-text">
              <div className="proc-num">04</div>
              <h3>ACL / PCL &amp; Ligament Reconstruction</h3>
              <p>Ligament tears are among the most feared injuries for athletes. Our ACL and PCL reconstruction uses advanced graft techniques and is augmented with PRP biologic therapy to improve graft integration and reduce recovery time.</p>
              <p style={{marginTop:12}}>Combined with our sports physiotherapy and rehabilitation program, most athletes return to full competitive sport within 4–6 months.</p>
              <div className="proc-chips">
                <span>ACL Reconstruction</span><span>PCL Repair</span><span>Multi-ligament</span><span>Sports Return</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:44}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Conditions Treated</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Conditions We <span className="acc">Treat</span></h2>
          </div>
          <div className="cond-grid">
            {['ACL Tear','PCL Tear','Meniscus Injury','Rotator Cuff Tear','Shoulder Instability / Dislocation','Cartilage Damage','Knee Osteoarthritis','Sports Injuries','Ankle Ligament Tears','Labral Tears','Patellofemoral Pain','IT Band Syndrome','Hamstring Injuries','Stress Fractures','Tennis / Golfer\'s Elbow','Shin Splints'].map(c=>(
              <div key={c} className="cond-chip">{c}</div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:44}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Your Specialist</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Meet Your <span className="acc">Orthopaedic Surgeon</span></h2>
          </div>
          <div className="doc-strip">
            <div className="doc-strip-img"><img src={SadhanPalakuri} alt="Dr. Sadhan Palakuri"/></div>
            <div className="doc-strip-info">
              <h3>Dr. Sadhan Palakuri</h3>
              <p className="dsi-qual">MBBS, MS.Ortho, FIAS, FIJR, FIPM</p>
              <p className="dsi-roles">Consultant Sports Orthopaedics · Arthroscopy Specialist · Regenerative OrthoBiologist</p>
              <p className="dsi-bio">Dr. Sadhan Palakuri is a fellowship-trained sports orthopaedic surgeon who has treated hundreds of athletes from club level to national level. His expertise in arthroscopic surgery combined with regenerative orthobiology delivers outcomes that go beyond conventional orthopaedic care.</p>
              <Link to="/doctors" className="btn-acc" style={{marginTop:16,display:'inline-flex'}}>Full Profile →</Link>
            </div>
          </div>
        </div>
      </section>

      <section style={{background:'#0D4E9A',padding:'72px 0',textAlign:'center'}}>
        <div className="container">
          <h2 style={{fontSize:'clamp(26px,3vw,38px)',fontWeight:800,color:'#fff',marginBottom:16}}>Ready to Get Back in the Game?</h2>
          <p style={{fontSize:16,color:'rgba(255,255,255,0.78)',maxWidth:500,margin:'0 auto 32px'}}>Book a consultation with Dr. Sadhan Palakuri and start your road to recovery today.</p>
          <Link to="/contact" className="btn-acc" style={{fontSize:16,padding:'14px 32px'}}>Book Consultation →</Link>
        </div>
      </section>
    </div>
  );
}
